/* ============================================================================
 * SYLONI® · Article Reading Progress Bar (Batch 2)
 *
 * 顶部金色阅读进度条，跟随滚动进度。
 * 自动注入到所有 article 页面（即 /blogs/X/Y 路径）。
 *
 * Last update: 2026-04-27 · Batch 2 v1.0.0
 * ============================================================================ */

(function () {
  'use strict';

  const isArticle =
    /\/blogs\/[^\/]+\/[^\/]+/.test(location.pathname) ||
    document.body.classList.contains('template-article');
  if (!isArticle) return;

  // Inject progress bar
  const bar = document.createElement('div');
  bar.id = 'syloni-article-progress';
  bar.setAttribute('aria-hidden', 'true');
  bar.style.cssText = [
    'position:fixed',
    'top:0',
    'left:0',
    'height:3px',
    'background:#D4AF37',
    'z-index:9999',
    'transition:width 100ms linear, opacity 300ms',
    'box-shadow:0 0 12px rgba(212,175,55,.5)',
    'width:0',
    'pointer-events:none',
  ].join(';');
  document.body.appendChild(bar);

  function getProgress() {
    const article =
      document.querySelector('article') ||
      document.querySelector('main') ||
      document.documentElement;
    const rect = article.getBoundingClientRect();
    const articleTop = rect.top + window.scrollY;
    const articleHeight = article.scrollHeight - window.innerHeight;
    const scrolled = window.scrollY - articleTop + window.innerHeight * 0.5;
    return Math.max(0, Math.min(1, scrolled / articleHeight));
  }

  let raf = null;
  function update() {
    raf = null;
    const p = getProgress();
    bar.style.width = (p * 100).toFixed(1) + '%';
    bar.style.opacity = p > 0.005 && p < 0.99 ? '1' : '0';
  }
  function onScroll() {
    if (raf) return;
    raf = requestAnimationFrame(update);
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  update();

  console.log(
    '%c SYLONI article-progress v1.0.0 ',
    'background:#D4AF37;color:#0A0A0A;padding:3px 8px;font-family:monospace;letter-spacing:2px;font-weight:600;'
  );
})();
